import { WebsiteSettingsState } from 'src/publisher/store/website-settings/website-settings-state-interface'
import { WebsitePageLocale } from 'src/shared/types/website-page-interface'
import {
  WebsiteButtonAndFormFieldTypes,
  WebsiteButtonsInterface,
  WebsiteButtonTypes,
  WebsiteFormFieldsSettings,
  WebsiteSettingsTypographyTypeEnum,
  WebsiteThemeButtonsInterface,
} from 'src/shared/types/website-settings-types'

export const getWebsiteStylesLayout = (state: WebsiteSettingsState) =>
  state.websiteStyles?.layout

export const getWebsiteStylesTypographyParagraph = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.typography?.paragraph

export const getWebsiteStylesTypographyHeading = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.typography?.heading

export const getWebsiteStylesPrimaryButtons = (state: WebsiteSettingsState) =>
  state.websiteStyles?.buttonsAndLinks?.primary

export const getWebsiteStylesSecondaryButtons = (state: WebsiteSettingsState) =>
  state.websiteStyles?.buttonsAndLinks?.secondary

export const getWebsiteStylesPrimaryButtonsTypography = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.buttonsAndLinks?.primary?.typography
export const getWebsiteStylesSecondaryButtonsTypography = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.buttonsAndLinks?.secondary?.typography

export const getWebsiteStylesFormFields = (state: WebsiteSettingsState) =>
  state.websiteStyles?.formFields

export const getWebsiteStylesFormFieldsTypography = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.formFields?.typography

export const getWebsiteTheme = (state: WebsiteSettingsState) =>
  state.websiteTheme

export const getWebsiteThemeBackground = (state: WebsiteSettingsState) =>
  state.websiteTheme?.background

export const getWebsiteLocales = (state: WebsiteSettingsState) =>
  state.websiteLocales

export const getDefaultWebsiteLocale = (state: WebsiteSettingsState) =>
  state.websiteDefaultLocale

export const getWebsiteActivePageIds = (state: WebsiteSettingsState) =>
  state.activePageIds

export const getWebsiteUserDomain = (state: WebsiteSettingsState) =>
  state.userDomain

export const websiteSettingsSelectors = {}

export const buttonAndFormFieldSelectorMap: Record<
  WebsiteButtonAndFormFieldTypes,
  (
    state: WebsiteSettingsState,
  ) => Partial<WebsiteButtonsInterface | WebsiteFormFieldsSettings> | undefined
> = {
  [WebsiteSettingsTypographyTypeEnum.PrimaryButton]:
    getWebsiteStylesPrimaryButtons,
  [WebsiteSettingsTypographyTypeEnum.SecondaryButton]:
    getWebsiteStylesSecondaryButtons,
  [WebsiteSettingsTypographyTypeEnum.FormField]: getWebsiteStylesFormFields,
}

export const typographySelectorMap = {
  [WebsiteSettingsTypographyTypeEnum.Paragraph]:
    getWebsiteStylesTypographyParagraph,
  [WebsiteSettingsTypographyTypeEnum.Heading]:
    getWebsiteStylesTypographyHeading,
  [WebsiteSettingsTypographyTypeEnum.PrimaryButton]:
    getWebsiteStylesPrimaryButtonsTypography,
  [WebsiteSettingsTypographyTypeEnum.SecondaryButton]:
    getWebsiteStylesSecondaryButtonsTypography,
  [WebsiteSettingsTypographyTypeEnum.FormField]:
    getWebsiteStylesFormFieldsTypography,
}

type WebsiteThemeButtonKeys = keyof WebsiteThemeButtonsInterface

interface ButtonColorKeysMapping {
  buttonTextColor: WebsiteThemeButtonKeys
  buttonBackgroundColor: WebsiteThemeButtonKeys
  hoveredButtonBackgroundColor: WebsiteThemeButtonKeys
  pressedButtonBackgroundColor: WebsiteThemeButtonKeys
}

export const buttonColorKeyMap: Record<
  WebsiteButtonTypes,
  ButtonColorKeysMapping
> = {
  [WebsiteSettingsTypographyTypeEnum.PrimaryButton]: {
    buttonTextColor: 'primaryButtonTextColor',
    buttonBackgroundColor: 'primaryButtonBackgroundColor',
    hoveredButtonBackgroundColor: 'primaryHoveredButtonBackgroundColor',
    pressedButtonBackgroundColor: 'primaryPressedButtonBackgroundColor',
  },
  [WebsiteSettingsTypographyTypeEnum.SecondaryButton]: {
    buttonTextColor: 'secondaryButtonTextColor',
    buttonBackgroundColor: 'secondaryButtonBackgroundColor',
    hoveredButtonBackgroundColor: 'secondaryHoveredButtonBackgroundColor',
    pressedButtonBackgroundColor: 'secondaryPressedButtonBackgroundColor',
  },
  // [WebsiteSettingsTypographyTypeEnum.GhostButton]: {
  //   buttonTextColor: 'ghostButtonTextColor',
  //   buttonBackgroundColor: 'ghostHoveredButtonBackgroundColor',
  //   hoveredButtonBackgroundColor: 'ghostHoveredButtonBackgroundColor',
  //   pressedButtonBackgroundColor: 'ghostPressedButtonBackgroundColor',
  // },
}
